import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import FilterMenuDateRangeLegacy from './_do_not_import_/FilterMenuDateRange';
import FilterMenuDateRangeV2, { IFilterMenuDateRangeProps } from './_do_not_import_v2_/FilterMenuDateRange';

export const FilterMenuDateRange = (props: IFilterMenuDateRangeProps) => {
  const flags = useFlags<{ bookingViewV2: boolean }>();

  if (flags.bookingViewV2) {
    return <FilterMenuDateRangeV2 {...props} />;
  }

  return <FilterMenuDateRangeLegacy {...props} />;
};
